mainApp.component('slaSettingsContainer', {
    templateUrl: '/public/components/configuration/slaSettings/sla-settings-container.component.html',
    bindings: {
        model: '<?',
        accountId: '<?',
        siteId: '<?',
        changeListener: '&',
        showOverrideCheckbox: '<?',
    },
    controller: slaSettingsContainerController
});


function slaSettingsContainerController(GeneralUtilsService, $scope, SlaSettingService) {
    const ctrl = this;

    ctrl.$onInit = () => {
        reload();
    }

    const reload = () => {
        initSlaDefaultValuesIfNeeded();
        if (ctrl.siteId){
            SlaSettingService.siteHasLastResortLinks(ctrl.accountId, ctrl.siteId, setHasSitesWithLastResortLinks);
        }
        ctrl.original = angular.copy(ctrl.model);
        ctrl.hasChanges = false;
    }

    ctrl.$doCheck = () => {
        if (!ctrl.changeListener)
            return;

        let isChangedNow = !angular.equals(ctrl.model, ctrl.original);

        // we only care when state is changed...
        if (ctrl.hasChanges === isChangedNow)
            return;

        ctrl.hasChanges = isChangedNow;
        ctrl.changeListener({componentName:'slaSetting', current: ctrl.model, hasChanges: ctrl.hasChanges});
    }

    $scope.$on('modelReloadedEvent', (event, data) => {
        reload();
    });

    const initSlaDefaultValuesIfNeeded = () => {
        if (!ctrl.model){
            ctrl.model = SlaSettingService.buildNewModel();
        }
    }

    const setHasSitesWithLastResortLinks = (response) => {
        ctrl.hasSitesWithLastResortLinks = response;
        $scope.$digest();
    }

    ctrl.disableLastResortSettings = () => {
        return !ctrl.hasSitesWithLastResortLinks;
    }
};
